import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { ResearchAmountVM } from 'front-office/view-models/research-amount';

export const transformDataset = (values: ResearchAmountVM): string => {
  const transformedFilters: OperationObject = {
    codiceImportoPagamento: { value: values.filter?.code || '', operation: Operation.LIKE },
    descrizioneImportoPagamento: {
      value: values.filter?.description || '',
      operation: Operation.LIKE,
    },
    dataInizioValidita: {
      value: values.filter?.dateFrom ? values.filter?.dateFrom.toFormat('yyyy-MM-dd') : '',
    },
    dataFineValidita: {
      value: values.filter?.dateTo ? values.filter?.dateTo.toFormat('yyyy-MM-dd') : '',
    },
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: {},
    // page,
    // rowsPerPage,
  })}`;
};
